import React from 'react';

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm';
  className?: string;
}

export function Input({ size, className = '', ...rest }: InputProps) {
  return (
    <input
      className={['input', size === 'sm' ? 'input-sm' : '', className].join(
        ' '
      )}
      {...rest}
    />
  );
}

export default Input;
